import { injectGlobal } from "@emotion/css";
let gate = true;
const grid = (gridParameter) => {
    if (gate) {
        gate = false;
        const bgImage = gridParameter.bgImage;
        const bgimageshow = gridParameter.bgimageshow;
        if (typeof bgImage === "string" && bgImage.length > 0 && typeof bgimageshow === "string" && bgimageshow.length > 0) {
            // TODO Not type safe
            injectGlobal `
.background-image {
    background-size: cover;
    background: url("${bgImage}") center center no-repeat;
}
`;
        }
    }
};
export { grid };
